import styled from 'styled-components';

export const Container = styled.div`
  @media screen and (orientation: landscape) {
    position: fixed !important;
    inset: -64px 0 0;
    z-index: 9000 !important;
  }
`;
